export default "__VITE_ASSET__eowYbw55__"